import { useState } from "react";

export interface UsePaginationOptions {
  initialPage: number;
  initialPageSize: number;
}

const usePagination = (
  { initialPage, initialPageSize }: UsePaginationOptions = {
    initialPage: 1,
    initialPageSize: 10,
  },
) => {
  const [current, setCurrentPage] = useState(initialPage);
  const [pageSize, setPageSize] = useState(initialPageSize);

  const onPageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize);
    setCurrentPage(1);
  };

  return {
    current,
    pageSize,
    onPageChange: setCurrentPage,
    onPageSizeChange: onPageSizeChange,
  };
};

export default usePagination;
